t = require('app/scripts/views/internal/teacup-with-helpers')('list')

module.exports = t.renderable ({ name, subscribed, loggedIn, editable, isTemplate, cardTemplatesFlagEnabled }) ->

  t.div '.list.js-list-content', ->

    headerClasses =
      'list-header': true
      'js-list-header': true
      'u-clearfix': true
      'is-menu-shown': loggedIn
      'is-subscribe-shown': subscribed

    t.div { class: t.classify(headerClasses) }, ->

      inputClasses =
        'list-header-name': true
        'mod-list-name': true
        'js-list-name-input': true

      t.div '.list-header-target.js-editing-target'

      t.h2 '.list-header-name-assist.js-list-name-assist', { dir: 'auto' }, name

      t.textarea { class: t.classify(inputClasses), 'aria-label': name, spellcheck: 'false', dir: 'auto', maxLength: 512 }, name

      t.div '.list-header-extras', ->

        subscribeClasses =
          'list-header-extras-subscribe': true
          'js-list-subscribed': true

        if !subscribed
          subscribeClasses['hide'] = true

        t.span { class: t.classify(subscribeClasses) }, ->
          t.span '.icon-sm.icon-subscribe.mod-quiet'

        t.span '.list-header-extras-limit-badge.js-list-limit-badge.hide'

        if (loggedIn && !isTemplate) || (loggedIn && isTemplate && editable)
          t.a '.list-header-extras-menu.dark-hover.js-open-list-menu.icon-sm.icon-overflow-menu-horizontal', {
            href: '#'
          }, ->
            t.div()

      t.p '.list-header-num-cards.hide.js-num-cards'

    if cardTemplatesFlagEnabled
      t.div '.card-composer-container.js-card-composer-container', ->
        t.a '.open-card-composer.card-templates-enabled.js-open-card-composer', { href: '#' }, ->
          t.icon 'add'
          t.span '.js-add-a-card', ->
            t.format 'add-a-card'
          t.span '.js-add-another-card.hide', ->
            t.format 'add-another-card'

        t.a '.icon-sm.icon-template-card.dark-background-hover.js-open-card-templates', { href: '#', 'aria-label': t.l('create-from-template') }
    else
      t.a '.open-card-composer.js-open-card-composer', { href: '#' }, ->
        t.icon 'add'
        t.span '.js-add-a-card', ->
          t.format 'add-a-card'
        t.span '.js-add-another-card.hide', ->
          t.format 'add-another-card'
